/* eslint-disable no-undef */
import angular from 'angular';

class UseTermsController {
  constructor(TrackingService) {
    this.trackingService = TrackingService;
  }

  $onInit() {
    //this.trackingService.track('useterms.open');
  }
}

angular.module('ll').component('useTerms', {
  template: function(LanguageService){
    if (__ENVIRONMENT__ === 'portugal') {
      return require('./useterms.component.pt.html');
    } else {
      let language = LanguageService.getLanguage();
      return language.startsWith('en') ? require('./useterms.component.en.html') : require('./useterms.component.sv.html');
    }
  },
  controller: UseTermsController,
  controllerAs: 'vm'
});
